/** Parse comma-separated tickers into uppercase unique values. */
export const parseCsvTickers = (value) => value
    .split(",")
    .map((item) => item.trim().toUpperCase())
    .filter(Boolean)
    .filter((item, idx, arr) => arr.indexOf(item) === idx);
export const toNumber = (value) => Number(value);
